import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailComposer } from '@ionic-native/email-composer/ngx';
import { Platform } from '@ionic/angular';
import { advertisement, ServiceService } from 'src/app/service.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.page.html',
  styleUrls: ['./company.page.scss'],
})
export class CompanyPage implements OnInit {
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();
  constructor(
    public services:ServiceService, 
    private platform:Platform, 
    private emailComposer:EmailComposer,
    private formBuilder:FormBuilder
  ) { }

  public errorMessages = {
    vacancy: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 200 caracteres.' }
    ],
    contactName: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 100 caracteres.' }
    ],
    companyName: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 100 caracteres.' }
    ],
    telephone: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 50 caracteres.' }
    ],
    email: [
      { type: 'required', message: '* Requerido' },
      { type: 'pattern', message: '* Ingresa un E-mail válido' },
      { type: 'maxlength', message: '* Máximo 100 caracteres.' }
    ],
    companyLocation: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 250 caracteres.' }
    ]
  };

  get vacancy(){
    return this.form.get("vacancy");
  }
  get contactName(){
    return this.form.get("contactName");
  }
  get companyName(){
    return this.form.get("companyName");
  }
  get telephone(){
    return this.form.get("telephone");
  }
  get email(){
    return this.form.get("email");
  }
  get companyLocation(){
    return this.form.get("companyLocation");
  }

  get termsConditions(){
    return this.form.get("termsConditions");
  }

  form = this.formBuilder.group({
    vacancy: ['',[Validators.required, Validators.maxLength(200)]],
    contactName: ['',[Validators.required, Validators.maxLength(100)]],
    companyName: ['',[Validators.required, Validators.maxLength(100)]],
    telephone: ['',[Validators.required, Validators.maxLength(50)]],
    email: ['',[Validators.required, Validators.maxLength(100), Validators.pattern('^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
    companyLocation: ['',[Validators.required, Validators.maxLength(250)]],
    termsConditions: [true,[Validators.requiredTrue]],
  });

  async ngOnInit() {
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(7);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  public openEmailDialog(){
    let emailSend = localStorage.getItem("emailEmpresas");
    const email = {
      to: emailSend,
      cc: [],
      attachments: [],
      subject: `publicacion de vacante '${this.form.get('vacancy').value}' ${this.form.get('companyName').value}`,
      body: `vacante: ${this.form.get('vacancy').value}
      Empresa: ${this.form.get('companyName').value}
      Nombre de contacto: ${this.form.get('contactName').value}
      Telefono: ${this.form.get('telephone').value}
      Correo: ${this.form.get('email').value}
      Ubicacion: ${this.form.get('companyLocation').value}
      Favor de publicar la vacante`,
      isHtml: false,
      app: "correo"
    };
    this.emailComposer.open(email).then((result : any)=> {
      //console.log(result);
      this.services.showAlert("Correo enviado exitosamente");
      this.services.goBack();
    });
    this.addPointsVacancy();
  }

  async addPointsVacancy(){
    (await this.services.addPointsPostVacancy()).subscribe(
      (data:any) => {
        if(data?.win) this.services.showAlert(`Obtuvo + ${data.pointsWin} puntos.`);
      },
      (error) => {
        console.log(error);
      },
    );
  }

}
